import { useMemo, useState } from 'react';
import { Panel } from '../../../components/panels/Panel';
import { Loader } from '../../../components/loading/Loader';
import {
  formatVeralliaDashboardDateTime,
  getVeralliaDashboardDefectClassification,
  getVeralliaDashboardLastCompletedShiftRange,
  getVeralliaDashboardLinesReporting,
  getVeralliaDashboardShiftEvolution,
} from '../../../services/dashboard/verallia-dashboard-service';
import { groupVeralliaDashboardDetections } from '../../../services/dashboard/verallia-dashboard-grouping-service';
import { VeralliaDashboardKpi, VeralliaDashboardNoData, VeralliaDashboardPictureWall } from './components/VeralliaDashboardBlocks';
import { VeralliaDashboardDefectClassification, VeralliaDashboardShiftEvolutionChart } from './components/VeralliaDashboardCharts';
import { VeralliaDashboardDetectionsTable } from './components/VeralliaDashboardDetectionsTable';

export const VeralliaDashboardLastShiftReport = ({ detections, isInfluxLoading, hasInfluxError }) => {
  const [page, setPage] = useState(1);
  const shiftRange = useMemo(() => getVeralliaDashboardLastCompletedShiftRange(), []);
  const shiftDetections = useMemo(() => detections.filter((detection) => detection.timestamp >= shiftRange.start && detection.timestamp < shiftRange.end), [detections, shiftRange]);
  const classification = useMemo(() => getVeralliaDashboardDefectClassification(shiftDetections), [shiftDetections]);
  const evolution = useMemo(() => getVeralliaDashboardShiftEvolution(shiftDetections, shiftRange), [shiftDetections, shiftRange]);
  const groupedCount = useMemo(() => groupVeralliaDashboardDetections(shiftDetections).length, [shiftDetections]);

  if (isInfluxLoading) return <Loader/>;

  return (
    <Panel title="INFORME DEL ÚLTIMO TURNO">
      <div className="mx-auto flex w-11/12 flex-col gap-4 py-6">
        {hasInfluxError ? <VeralliaDashboardNoData text="No se han podido cargar los datos."/> : (
          <>
            <div className="text-sm text-perception-gray-600">Turno {shiftRange.id} · {formatVeralliaDashboardDateTime(shiftRange.start, false)} → {formatVeralliaDashboardDateTime(shiftRange.end, false)} · cerrado</div>
            <div className="grid grid-cols-2 gap-4">
              <VeralliaDashboardKpi label="Detecciones en el turno" value={shiftDetections.length}/>
              <VeralliaDashboardKpi label="Líneas afectadas" value={getVeralliaDashboardLinesReporting(shiftDetections)}/>
            </div>
            <div className="grid grid-cols-1 gap-4 2xl:grid-cols-2">
              <VeralliaDashboardShiftEvolutionChart evolution={evolution}/>
              <VeralliaDashboardDefectClassification classification={classification} fixedHeight/>
            </div>
            <VeralliaDashboardPictureWall detections={shiftDetections}/>
            <div className="flex flex-col gap-3">
              <div className="text-xs font-semibold uppercase tracking-wider text-perception-gray-600">Detecciones del turno · {groupedCount} registros{groupedCount !== shiftDetections.length ? ` (${shiftDetections.length} capturas)` : ''}</div>
              <VeralliaDashboardDetectionsTable detections={shiftDetections} page={page} onPageChange={setPage}/>
            </div>
          </>
        )}
      </div>
    </Panel>
  );
};
